/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'plurk': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#ea4640" d="M0 0h32v32H0V0z"/><path pid="1" _fill="#fff" d="M16.172 12.459c1.023 0 1.895.838 1.878 1.861a1.832 1.832 0 01-1.83 1.799h-2.269v-1.571c0-1.154.935-2.088 2.088-2.088h.133z"/><path pid="2" _fill="#fff" d="M16.773 5.871c5.06 0 9.147 4.056 8.753 9.099-.335 4.29-3.827 7.277-8.208 7.444-.439 2.342-2.929 3.714-5.233 3.714-3.108 0-5.636-2.364-5.636-5.471v-5.839c0-5.063 4.104-8.947 9.166-8.947h1.159zm5.156 8.418c0-1.385-.561-2.638-1.469-3.546s-2.161-1.468-3.545-1.468h-1.336a5.508 5.508 0 00-5.508 5.508v5.874a2.012 2.012 0 004.026 0v-1.354h2.818a5.014 5.014 0 005.014-5.014z"/>'
  }
})
